import Axios from "axios";
import {AUTH_CREDENTIALS_NAME, APIURL} from "./../Constantes";

const getCabecera = () =>{
    let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
    let cabecera = { Authorization: `bearer ${Token}`,
    "Content-Type": "application/json",
    Accept: "application/json",}
    return cabecera;
}

const urlDuck = "Departure";

const dataInicial = {
  array: [],
  exito: 0,
  objeto: {},
};

const GET_SALIDAS_ALL = "GET_SALIDAS_ALL";
const GET_SALIDAS_BY_PAQUETE = "GET_SALIDAS_BY_PAQUETE";
const GET_SALIDAS_CLEAR_STATE = "GET_SALIDAS_CLEAR_STATE";
const POST_SALIDAS_BLOQUE = "POST_SALIDAS_BLOQUE";
const DELETE_SALIDAS_BLOQUE = "DELETE_SALIDAS_BLOQUE";

export default function salidasReducer (state = dataInicial, action) {
  switch (action.type) {
    case DELETE_SALIDAS_BLOQUE:
      return { ...state, action: action.payload.exito };
    case POST_SALIDAS_BLOQUE:
      return { ...state, exito: action.payload.exito };
    case GET_SALIDAS_ALL:
      return { ...state, array: action.payload.array };
    case GET_SALIDAS_BY_PAQUETE:
      return { ...state, array: action.payload.array };
    case GET_SALIDAS_CLEAR_STATE: 
      return {...state, array: action.payload.array, exito: action.payload.exito, objeto: action.payload.objeto}
    default:
      return state;
  }
}
export const eliminarBloqueSalidasPaqueteAction = (idPaquete, idBloque) => async (dispatch) =>{
  try {
    const respuesta = await Axios.delete(`${APIURL}/${urlDuck}/Package/${idPaquete}/${idBloque}`,
    {
        headers: getCabecera()
    });
    dispatch({
        type: DELETE_SALIDAS_BLOQUE,
        payload: {
            exito: 1
        }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
}
export const altaBloqueSalidasAction = (payload) => async (dispatch) =>{
  try {
    const respuesta = await Axios.post(`${APIURL}/${urlDuck}/AddBlock`, payload,
    {
        headers: getCabecera()
    });
    dispatch({
        type: POST_SALIDAS_BLOQUE,
        payload: {
            exito: 1
        }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
}
export const obtenerSalidasByIdPaqueteAction = (IdPaquete) => async (dispatch) => {
  try {
    const respuesta = await Axios.get(`${APIURL}/${urlDuck}/Package/${IdPaquete}`,
    {
        headers: getCabecera()
    });
    dispatch({
        type: GET_SALIDAS_BY_PAQUETE,
        payload: {
            array: respuesta.data
        }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
};

export const clearSalidasState = () => async (dispatch) =>{
    dispatch({
        type: GET_SALIDAS_CLEAR_STATE,
        payload :{
          array: [],
          exito: 0,
          objeto: {}
        }
    })
}
